import { __rest } from "tslib";
import { getClipParams } from '../../utils/animationsUtils';
import { toArray } from '@wix/wow-utils';
const name = 'BaseClipPath';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, _a = {}) {
    var { to = {}, from = {}, useClipRect = false } = _a, params = __rest(_a, ["to", "from", "useClipRect"]);
    const sequence = kit.sequence();
    elements = toArray(elements);
    elements.forEach((element) => {
        const compRect = kit.engine.getBoundingRect(element);
        const contentRect = kit.engine.getBoundingContentRect(element);
        const initialClipPath = getClipParams(compRect, contentRect, 'initial', {
            useClipRect,
        });
        sequence.add(kit.engine.tween(element, Object.assign({ duration,
            delay, to: Object.assign(Object.assign({}, initialClipPath), to), from: Object.assign(Object.assign({}, initialClipPath), from) }, params), ['clipPath', 'webkitClipPath', 'clip']), 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=baseClipPath.js.map